import { render, staticRenderFns } from "./SalesListGrid.vue?vue&type=template&id=3453bb06"
import script from "./SalesListGrid.vue?vue&type=script&lang=js"
export * from "./SalesListGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports